module.exports = __webpack_public_path__ + "static/media/background.404b7d02.png";